import { z } from 'zod';

const IAMSchema = z.string().regex(/^\/iam\/(users|organizations)\//);

export const MetaSchema = z.object({
	createdAt: z.int(),
	createdBy: z
		.object({
			self: IAMSchema,
		})
		.nullable(),
	updatedAt: z.int(),
	updatedBy: z
		.object({
			self: IAMSchema,
		})
		.nullable(),
	version: z.int().min(1),
});

export type IMetaSchema = z.infer<typeof MetaSchema>;
